// src/components/ComiteEventos.jsx
import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Button, Spinner } from "react-bootstrap";
import NewsCard from "./NewsCard";
import { Link } from "react-router-dom";

const API_URL = "https://facach.coop.hn/api";

// ─────────────────────────────────────────────────────────────────────────────
// Props:
//   committeeCode  → "educacion" | "juventud" | "genero"
//   limit          → cuántos eventos mostrar (default 3)
//   verTodasLink   → ruta del botón "Ver todas" (default "/noticiasComite")
// ─────────────────────────────────────────────────────────────────────────────
const ComiteEventos = ({
  committeeCode,
  limit = 3,
  verTodasLink = "/noticiasComite",
}) => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);

  useEffect(() => {
    if (!committeeCode) return;

    const fetchEventos = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          `${API_URL}/committee/${committeeCode}/events?limit=${limit}`
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok) setEventos(json.data);
      } catch (err) {
        console.error(`Error cargando eventos de ${committeeCode}:`, err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEventos();
  }, [committeeCode, limit]);

  const handleVerMas = (item) => {
    setEventoSeleccionado(item);
    setShowModal(true);
  };

  // Mapear formato de API al formato que espera NewsCard
  const toNewsCardFormat = (evento) => ({
    id: evento.id,
    titulo: evento.title,
    fecha: evento.event_date,
    imagen: evento.image_url,
    contenido: evento.description_html,
    autor: "",
  });

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" size="sm" />
      </div>
    );
  }

  if (eventos.length === 0) {
    return (
      <p className="text-muted text-center py-3">
        No hay eventos publicados aún.
      </p>
    );
  }

  return (
    <>
      <Row className="g-4 mt-1">
        {eventos.map((evento) => (
          <Col md={4} key={evento.id}>
            <NewsCard
              item={toNewsCardFormat(evento)}
              onVerMas={() => handleVerMas(evento)}
            />
          </Col>
        ))}
      </Row>

      <div className="mt-3">
        <Link
          to={verTodasLink}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            color: "#1565c0",
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
            borderBottom: "2px solid #1565c0",
            paddingBottom: 2,
            transition: "all 0.15s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.color = "#1a3a6b";
            e.currentTarget.style.borderBottomColor = "#1a3a6b";
            e.currentTarget.style.gap = "10px";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.color = "#1565c0";
            e.currentTarget.style.borderBottomColor = "#1565c0";
            e.currentTarget.style.gap = "6px";
          }}
        >
          Ver todas los eventos
         
        </Link>
      </div>

      {/* ── Modal detalle del evento ──────────────────────────────────────── */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        contentClassName="modal-news"
      >
        {eventoSeleccionado && (
          <Modal.Body>
            <div className="news-modal-content">
              {eventoSeleccionado.image_url && (
                <img
                  src={eventoSeleccionado.image_url}
                  alt={eventoSeleccionado.title}
                  className="news-modal-img"
                />
              )}
              <h3 className="mt-3">{eventoSeleccionado.title}</h3>
              <small className="text-muted">
                {eventoSeleccionado.event_date &&
                  new Date(eventoSeleccionado.event_date).toLocaleDateString(
                    "es-HN",
                    { year: "numeric", month: "long", day: "numeric" }
                  )}
              </small>
              {/* Renderiza el HTML del CMS */}
              <div
                className="mt-3"
                dangerouslySetInnerHTML={{
                  __html: eventoSeleccionado.description_html,
                }}
              />
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export default ComiteEventos;